import { render, staticRenderFns } from "./IconStore.vue?vue&type=template&id=ba2b501e&functional=true&"
import script from "./IconStore.vue?vue&type=script&lang=js&"
export * from "./IconStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports